import React from 'react';
import {useState, useEffect} from 'react';
import './Product.css';
import * as _ from 'underscore'
import QuickSpecs from './QuickSpecs'
import * as $ from 'jquery'
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
let USDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});

class Product extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {};
    // Take the first available spec category and expand it by default
    _.any(this.props.product.specs, (spec) => {
      if (spec.name != 'Quick Specs') {
        this.state['specs-' + spec.name] = true;
        return true;
      }
    });
    this.state.variant = this.props.product.variants[0];
    this.state.variantChangedAt = 0; // this is for keeping the color after the user manually clicks

    // Accessories to display: featured accessories only (capped at 6), no padding
    // with non-featured accessories. Computed once here rather than in render() so
    // the selection doesn't reshuffle on every re-render (variant cycling, scroll,
    // etc). The Accessories tab/section is only shown when this ends up non-empty
    // (checked directly at render time, not via a separate flag here --
    // validateDisplayAccessories() can shrink this list later if an image fails to
    // load, and a flag captured once in the constructor wouldn't track that).
    const hasImage = (accessory) => accessory.images && accessory.images.main;
    const featured = _.filter(this.props.product.accessories, (accessory) =>
      accessory.variants[0].isFeatured && hasImage(accessory)
    );
    this.state.displayAccessories = _.first(featured, 6);
  }

  componentDidMount() {
    this._isMounted = true;
    this.interval = setInterval(()=> {
      if (Date.now() - this.state.variantChangedAt > 60000) { // After a minute we can go back to cycling
        const index = _.indexOf(this.props.product.variants, this.state.variant);
        this.setState({variant: this.props.product.variants[(index + 1) % this.props.product.variants.length]});
      }
    }, 15000);

    this.validateDisplayAccessories();
  }
  componentWillUnmount () {
    this._isMounted = false;
    clearInterval(this.interval);
    clearTimeout(this.accessoryTimeout);
  }

  loadImage(url) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve();
      img.onerror = () => reject(new Error(`Failed to load ${url}`));
      img.src = url;
    });
  }

  // Confirms each displayed accessory's image actually loads (a broken/missing
  // file is more common than it should be -- see the accessory-image sync gaps
  // we've hit before) and silently swaps in a different, not-yet-tried *featured*
  // accessory when one fails, so a dead image link never leaves an empty or
  // broken-looking tile on screen. Replacement pool is featured-only, same as the
  // constructor -- a non-featured accessory should never end up on screen just
  // because a featured one's image happened to fail to load.
  async validateDisplayAccessories() {
    const hasImage = (accessory) => accessory.images && accessory.images.main;
    const usedCodes = new Set(this.state.displayAccessories.map((a) => a.code));
    const remainingPool = _.shuffle(
      _.filter(this.props.product.accessories, (a) =>
        a.variants[0].isFeatured && hasImage(a) && !usedCodes.has(a.code)
      )
    );

    const finalList = [];
    for (const original of this.state.displayAccessories) {
      let candidate = original;
      while (candidate) {
        try {
          await this.loadImage(`/data/${candidate.images.main}`);
          finalList.push(candidate);
          break;
        } catch (err) {
          console.warn(`Accessory image failed to load, swapping it out: ${candidate.name}`, err);
          usedCodes.add(candidate.code);
          candidate = remainingPool.shift(); // next random replacement, or undefined if the pool's exhausted
        }
      }
      // If candidate is falsy the whole pool was exhausted -- that slot is just
      // dropped, same as when a product simply doesn't have enough accessories.
    }

    if (this._isMounted) {
      this.setState({displayAccessories: finalList});
    }
  }

  renderFeaturedAccessory() {
    const {accessory} = this.state;
    return <div id="selected-accessory">

      <button style={{
        top: '.7vw',
        padding: '1vw 2vw',
        right: '1vw',
        position: 'absolute',
        fontSize: '3vw',
        background: 'white',
        border: 0,
      }} onClick={(e) =>
        this.setState({accessory: null})
      }>
        &times;
      </button>

      <div style={{
        borderBottom: '2px solid #cccccc',
        height: '2.05vw',
        marginLeft: '1.2vw',
        marginRight: '2.5vw',
        marginBottom: '1.5vw',
      }}>
        <div style={{
          background: 'white',
          display: 'inline-block',
          margin: 'auto',
          fontSize: '3vw',
          fontWeight: 'bold',
          padding: '0 1vw',
        }}>
          {this.props.product.name} Featured Accessory
        </div>
      </div>

      <div style={{
        padding: '5vw'
      }}>
        <div>
          <div  style={{
            backgroundImage: `url('/data/${accessory.images.main}')`,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '50% 50%',
            backgroundColor: '#fafafa',
            width: '50%',
            height: '30vw',
            float: 'left',
          }} />
          <div style={{
            width: '50%',
            float: 'left',
            padding: '0 3vw',
            textAlign: 'left',
          }}>
            <div style={{
              fontSize: '5vw',
            }}>
              {accessory.name}
            </div>
            <div style={{
              marginTop: '2vw',
              fontSize: '2.5vw',
            }}>
              Suggested Retail Price of {USDollar.format(accessory.variants[0].msrp)}
            </div>
          </div>
          <div style={{clear: 'both'}} />
        </div>
        <div style={{
          padding: '0 .5vw',
          textAlign: 'left',
          fontSize: '2.5vw',
        }} dangerouslySetInnerHTML={{__html: accessory.variants[0].longDescription}} />
      </div>

    </div>
  }

  render() {
    const {product} = this.props;
    return <div>
      <div id="ocean-backdrop">
        <div id="ocean-backdrop-inner" className={(product.type == 'PWC' ? 'pwc' : '')} />
        <div id="left-info">
          <div id="product-name">
            {product.name}
          </div>
          <div id="color-swatches">
            <div className='available-in-text' style={{
              paddingRight: '2vw',
              paddingBottom: '.3vw',
            }}>
              Available in:
            </div>
            {product.variants.map((variant) => {
              return <img
                className="color-swatch"
                src={`/data/images/${variant.images.swatch}`}
                alt="none"
                onClick={(e) =>
                  this.setState({variant, variantChangedAt: Date.now()})
                }
              />
            })}
          </div>
        </div>
        {product.variants.map( variant => 
          <div className="boat-side" style={{
            backgroundImage: `url('/data/images/${variant.images.alternate}')`,
            zIndex: variant == this.state.variant ? 10 : 5,
            opacity: variant == this.state.variant ? 1 : 0,
          }} />
        )}
      </div>
      <QuickSpecs product={product} />
      <div id="product-nav">
        {_.compact([
          {selector: '#specifications-section', title: 'Specifications'},
          this.state.displayAccessories.length > 0 && {selector: '#accessories-section', title: 'Accessories'},
        ]).map(({selector, title}) =>
          <button key={selector} onClick={() => {
            $(window).scrollTop(
              $(selector).offset().top - $(window).width() * .50
            )
            this.setState({accessory: null});
          }}>
            {title}
          </button>
        )}
      </div>
      <div id="specifications-section" style={{
        margin: '2vw 5vw',
        paddingTop: '2.5vw',
      }}>
        <div style={{
          borderBottom: '2px solid #d5d5d5',
          height: '2.3vw',
          marginLeft: '1.2vw',
          marginRight: '2.5vw',
          marginBottom: '3.5vw',
        }}>
          <div style={{
            background: '#ffffff',
            display: 'inline-block',
            margin: 'auto',
            fontSize: '3vw',
            fontWeight: 'bold',
            padding: '0 1vw',
          }}>
            Specifications
          </div>
        </div>
        <div style={{borderBottom: '.33vw solid #eee'}}>
        {_.compact(_.map(product.specs, (specs) => {
          if (specs.name == 'Quick Specs') return;
          const key = 'specs-' + specs.name;
          return <div>
            <div className='specs-header' onClick={()=>
              this.setState({[key]: !this.state[key]})
            }>
              <div style={{
                float: 'right'
              }}>{this.state[key] ? '-' : '+'}</div>
              {specs.name}
            </div>
            {this.state[key] &&
              <div>
                {_.compact(specs.tabDataItems.map((spec) => {
                  if (spec.value) {
                    return <div className='specs-row'>
                      <div className='specs-column'>
                        {spec.name}
                      </div>
                      <div className='specs-column'>
                        {spec.value === true || spec.value === "true" ? <i className='fa-solid fa-circle-check' /> : spec.value}
                      </div>
                    </div>
                  }
                }))}
              </div>
            }
          </div>;
        }))}
        </div>
      </div>
      {this.state.displayAccessories.length > 0 &&
        <div id="accessories-section" style={{
          margin: '4vw 0px 0',
          background: '#fafafa',
          paddingLeft: '1.3vw',
          paddingTop: '2.5vw',
          paddingBottom: '2.5vw',
        }}>
          <div style={{
            borderBottom: '2px solid #d5d5d5',
            height: '2.3vw',
            marginLeft: '1.2vw',
            marginRight: '2.5vw',
            marginBottom: '3.5vw',
          }}>
            <div style={{
              background: '#fafafa',
              display: 'inline-block',
              margin: 'auto',
              fontSize: '3vw',
              fontWeight: 'bold',
              padding: '0 1vw',
            }}>
              Accessories
            </div>
          </div>
          {this.state.accessory && this.renderFeaturedAccessory()}
          {this.state.displayAccessories.map((accessory) =>
            <div className='accessory' onClick={(e) => {
              //$('html,body').animate({scrollTop: $(e.target).offset().top});
              this.setState({accessory});
              clearTimeout(this.accessoryTimeout);
              this.accessoryTimeout = setTimeout(()=> this.setState({accessory: null}), 5 * 60 * 1000);
            }}>
              <div className='accessory-image' style={{
                backgroundImage: `url('/data/${accessory.images.main}')`
              }} />
              <div className='accessory-text'>
                {accessory.name}
              </div>
            </div>
          )}
          <div style={{clear: 'both'}} />
        </div>
      }
    </div>;
  }
}

export default Product;
